<template>
  <div class="step-3">等待游戏开始...</div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.step-3 {
  font-weight: 600;
  text-align: center;
}
</style>
